import $ from 'jquery'

export default function(context = document.body)
{
	const $context = $(context)

	$context.find('[data-filter]').each(function()
	{
		const $el = $(this)
		const $select = $el.find('select')
		const linkMap = $el.data('filter')

		$select.on('change', e =>
		{
			const value = $select.val()
			const url = linkMap.replace('*', value === 'all' ? '' : value)

			location.href = url
		})
	})
}



// WEBPACK FOOTER //
// ./source/scripts/components/filter.js